import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, NavLink } from "react-router-dom";
import AccountSidebar from "./AccountSidebar";
import { useSelector } from "react-redux";
import { currentRoute } from "@/utility/currentRoute";
import Icon from "@/components/units/Icon"

const Account = () => {
  const [currTab, setCurrTab] = useState("Profile");
  const isMobile = useSelector((state: any) => state.global.device.below.sm);
  const navigate = useNavigate();

  const handleTabChange = (tab: string) => {
    setCurrTab(tab);
  };

  useEffect(()=>{
    !isMobile && navigate("/account/profile")
  },[])

  return (
    <div className="tw-p-6">
      <h1 className="tw-text-primaryBlack tw-text-[24px] tw-font-nmmed">
        {currTab}
      </h1>
      <h4 className="tw-flex tw-items-center tw-text-xs tw-text-customGray67 ">
        <NavLink
          to="/"
          >
          Home 
        </NavLink>
        <Icon
            iconName="right-arrow"
            wrapperStyle="tw-w-5 tw-h-5 tw-p-1 tw-box-content tw-flex tw-justify-center tw-items-center tw-text-customGray67  tw-rounded-md"
        />
        <div className="tw-text-primaryDark">
          {currTab}
        </div>
      </h4>
      <div className="tw-flex tw-mt-6 tw-gap-6">
        {isMobile ? (
          currentRoute("/account").isCurrentRoute  ||
          currentRoute("/account/").isCurrentRoute ? (
            <AccountSidebar
              handleTabChange={handleTabChange}
              currTab={currTab}
            />
          ) : (
            <Outlet />
          )
        ) : (
          <>
            <AccountSidebar
              handleTabChange={handleTabChange}
              currTab={currTab}
            />
            <Outlet />
          </>
        )}
      </div>
    </div>
  );
};

export default Account;
